export type TCGOption = {
  id: string
  name: string
  logo: string
}

// Order mirrors the HoloDex onboarding card grid (Pokémon → Star Wars).
// Flesh and Blood is held at the bottom since it isn't on that list.
export const TCGS: TCGOption[] = [
  { id: 'pokemon', name: 'Pokémon', logo: '/logos/pokemon.png' },
  { id: 'onepiece', name: 'One Piece', logo: '/logos/onepiece.png' },
  { id: 'mtg', name: 'Magic: The Gathering', logo: '/logos/magicthegathering.png' },
  { id: 'yugioh', name: 'Yu-Gi-Oh!', logo: '/logos/yugioh.png' },
  { id: 'lorcana', name: 'Lorcana', logo: '/logos/lorcana.png' },
  {
    id: 'dbsfw',
    name: 'Dragon Ball Fusion World',
    logo: '/logos/dragonball-fusion-world.png',
  },
  {
    id: 'dbscg',
    name: 'Dragon Ball Super',
    logo: '/logos/dragonballsuper.png',
  },
  { id: 'digimon', name: 'Digimon', logo: '/logos/digimon.png' },
  { id: 'gundam', name: 'Gundam', logo: '/logos/gundam.png' },
  { id: 'unionarena', name: 'Union Arena', logo: '/logos/unionarena.png' },
  { id: 'riftbound', name: 'Riftbound', logo: '/logos/riftbound.png' },
  { id: 'starwars', name: 'Star Wars Unlimited', logo: '/logos/starwars.png' },
  { id: 'fab', name: 'Flesh and Blood', logo: '/logos/fleshandblood.png' },
]
